import { render, staticRenderFns } from "./ModifyPwd.vue?vue&type=template&id=0dc35bd6&scoped=true&"
import script from "./ModifyPwd.vue?vue&type=script&lang=js&"
export * from "./ModifyPwd.vue?vue&type=script&lang=js&"
import style0 from "./ModifyPwd.vue?vue&type=style&index=0&id=0dc35bd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc35bd6",
  null
  
)

export default component.exports